query WfaComponentSampleIssue($runId: ConditionID!, $textSearch: issuesSearchInsensitive) {
	issues(run_id_eq: $runId, text_equals: $textSearch, limit: 1) {
		type_name
		severity_name
		elements__selector
		elements__component_id
		elements__page_url
		elements__dom_snippet
		screenshot
		elements__bounding_box_top
		elements__bounding_box_left
		elements__bounding_box_width
		elements__bounding_box_height
	}
}
